import { useTranslation } from 'react-i18next'
import { PageHeader } from '@/ui/shared'
import { PdfViewer } from '@/ui/components/pdf-viewer'
import rateCardPdf from '@/assets/documents/rever-rate-card.pdf'

export default function RateCard() {
  const { t } = useTranslation()

  return (
    <div className="flex h-full flex-col overflow-y-auto bg-white">
      <PageHeader
        title={t('rate_card.title')}
        description={t('rate_card.description')}
      />
      <PdfViewer src={rateCardPdf} errorMessage={t('rate_card.load_error')} />
    </div>
  )
}
